import { render, staticRenderFns } from "./ModalHistoryChange.vue?vue&type=template&id=60d25944&scoped=true"
import script from "./ModalHistoryChange.vue?vue&type=script&lang=js"
export * from "./ModalHistoryChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d25944",
  null
  
)

export default component.exports